import { getPageModel } from '@/api/carModel'
import { Message } from '@qs/ui'
import { copyToClipboard } from '@/utils/index'

const copyId = (id) => {
  copyToClipboard(id, () => {
    Message.success('复制成功')
  })
}
export const config = ({
  modelYearList,
  showModelDetail,
  customizeReset,
}) => {
  return {
    formData: {
      list: [
        {
          itemConfig: {
            prop: 'brandSeriesModel',
          },
          elConfig: {
            showModel: false,
          },
          render: 'CarBrandSeriesModel',
        },
        {
          el: 'select',
          itemConfig: {
            label: '车型年款',
            prop: 'modelYear',
          },
          elConfig: {
            clearable: true,
            filterable: true,
            placeholder: '请选择',
            options: {
              label: 'label',
              value: 'value',
              list: modelYearList,
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '运营类型',
            prop: 'operationType',
          },
          elConfig: {
            clearable: true,
            filterable: true,
            placeholder: '请选择',
            options: {
              label: 'name',
              value: 'code',
              list: [],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '能源类型',
            prop: 'energyType',
          },
          elConfig: {
            clearable: true,
            filterable: true,
            placeholder: '请选择',
            options: {
              label: 'name',
              value: 'code',
              list: [],
            },
          },
        },
      ],
      dealWithSearch: (params) => {
        // 品牌车型车系参数处理
        const { brandSeriesModel, modelYear } = params
        if (brandSeriesModel) {
          const { brandId, seriesId } = brandSeriesModel
          params.seriesId = seriesId
          params.brandId = brandId
        }
        params.modelYear = modelYear || null
        delete params.brandSeriesModel
        params = {
          ...params,
        }
        return params
      },
      customizeReset,
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            label: '车型id',
            prop: 'id',
          },
          render: ({ row }) => {
            return <div>
              <span>{row.id}</span>
              <el-button type="text" class="copy" onClick={() => copyId(row.id)}>复制</el-button>
            </div>
          },
        },
        {
          name: 'brandName',
          columnProps: {
            label: '品牌名称',
            prop: 'brandName',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            label: '车系名称',
            prop: 'seriesName',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            label: '车型名称',
            prop: 'modelName',
          },
        },
        {
          name: 'modelYear',
          columnProps: {
            label: '车型年款',
            prop: 'modelYear',
          },
          getText: ({ row }) => (row.modelYear ? `${row.modelYear}款` : '--'),
        },
        {
          name: 'operationTypeName',
          columnProps: {
            label: '运营类型',
            prop: 'operationTypeName',
          },
        },
        {
          name: 'energyTypeName',
          columnProps: {
            label: '能源类型',
            prop: 'energyTypeName',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            prop: 'operate',
          },
          showSetting: false,
          type: 'operate',
          getOperateList: ({ row }) => {
            return [
              { label: '详情', action: () => showModelDetail(row) },
            ]
          },
        },
      ],
      apiFn: getPageModel,
    },
    isShowDepartment: false,
  }
}
